import { useUrlOverlay, type UrlOverlay } from "@/lib/useUrlOverlay";
import {
  QUOTE_MARK,
  QUOTE_PARAM,
  readQuotePopup,
} from "@/lib/submissions/quotePopup";

const QUOTE_POPUP: UrlOverlay = {
  param: QUOTE_PARAM,
  read: readQuotePopup,
  mark: QUOTE_MARK,
};

/**
 * The quote popup's open card, from the URL (BRK-S347), by any URL overlay's
 * rules (`useUrlOverlay`): `open` pushes the card's key, so Back closes the
 * popup; `close` never goes back twice; `closeThen` runs once it's gone.
 */
export function useQuotePopup() {
  const { value: key, open, close, closeThen } = useUrlOverlay(QUOTE_POPUP);
  return { key, open, close, closeThen };
}
